import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import Gmail from "@/pages/Gmail";
import Impact from "@/pages/Impact";
import Clients from "@/pages/Clients";
import Marketing from "@/pages/Marketing";
import RequestPilot from "@/pages/RequestPilot";
import { PasteDialog } from "@/components/PasteDialog";
import { ReviewDialog } from "@/components/ReviewDialog";
import { WalkthroughPanel } from "@/components/WalkthroughPanel";

function App() {
  const [pasteOpen, setPasteOpen] = useState(false);
  const [review, setReview] = useState(null);
  const [reviewOpen, setReviewOpen] = useState(false);
  const [refreshTick, setRefreshTick] = useState(0);
  const [walkthroughOpen, setWalkthroughOpen] = useState(false);

  const onAnalyzed = (res) => {
    setReview(res);
    setReviewOpen(true);
  };
  const bumpRefresh = () => setRefreshTick((n) => n + 1);

  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            fontFamily: '"IBM Plex Sans", sans-serif',
            border: "1px solid #E5E5E5",
            background: "#FFFFFF",
            color: "#171717",
          },
        }}
      />
      <BrowserRouter>
        <WalkthroughPanel open={walkthroughOpen} onClose={() => setWalkthroughOpen(false)} />
        <Routes>
          <Route path="/" element={<Marketing />} />
          <Route path="/request-pilot" element={<RequestPilot />} />
          <Route
            path="/app"
            element={
              <Dashboard
                setPasteOpen={setPasteOpen}
                refreshTick={refreshTick}
              />
            }
          />
          <Route
            path="/app/commitments"
            element={
              <Dashboard
                setPasteOpen={setPasteOpen}
                refreshTick={refreshTick}
                commitmentsOnly
              />
            }
          />
          <Route path="/app/conversations" element={<Gmail setPasteOpen={setPasteOpen} onAnalysis={onAnalyzed} />} />
          <Route path="/app/impact" element={<Impact setPasteOpen={setPasteOpen} />} />
          <Route path="/app/clients" element={<Clients setPasteOpen={setPasteOpen} />} />
          <Route path="/app/clients/:slug" element={<Clients setPasteOpen={setPasteOpen} />} />
        </Routes>
      </BrowserRouter>

      <PasteDialog open={pasteOpen} onOpenChange={setPasteOpen} onAnalyzed={onAnalyzed} />
      <ReviewDialog
        open={reviewOpen}
        onOpenChange={setReviewOpen}
        analysis={review}
        onAccepted={(items, sourceThreadId) => {
          bumpRefresh();
          window.dispatchEvent(new CustomEvent("cl:accepted", { detail: items }));
          if (sourceThreadId) {
            window.dispatchEvent(new CustomEvent("cl:threadAccepted", { detail: { sourceThreadId } }));
          }
        }}
        onFulfilled={() => {
          bumpRefresh();
          window.dispatchEvent(new CustomEvent("cl:fulfilled"));
        }}
      />
    </div>
  );
}

export default App;
